(() => {
  const initializedSections = new WeakSet();

  const setAnswerHeight = (item, open, animate = true) => {
    const answer = item.querySelector('[data-faq-answer]');
    const trigger = item.querySelector('[data-faq-trigger]');

    if (!answer || !trigger) return;

    if (!animate) answer.style.transition = 'none';

    if (open) {
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      answer.style.height = '0px';
      answer.offsetHeight;
      answer.style.height = `${answer.scrollHeight}px`;
    } else {
      answer.style.height = `${answer.scrollHeight}px`;
      answer.offsetHeight;
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      answer.style.height = '0px';
    }

    if (!animate) {
      answer.offsetHeight;
      answer.style.transition = '';
      if (open) answer.style.height = 'auto';
    }
  };

  const initializeSection = (section) => {
    if (initializedSections.has(section)) return;
    initializedSections.add(section);

    const items = Array.from(section.querySelectorAll('[data-faq-item]'));
    const loadMoreButton = section.querySelector('[data-faq-load-more]');
    const itemsPerLoad = Math.max(1, Number(section.dataset.itemsPerLoad) || 1);

    items.forEach((item, index) => {
      setAnswerHeight(item, index === 0, false);

      const trigger = item.querySelector('[data-faq-trigger]');
      trigger?.addEventListener('click', () => {
        const shouldOpen = !item.classList.contains('is-open');

        items.forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains('is-open')) {
            setAnswerHeight(otherItem, false);
          }
        });

        setAnswerHeight(item, shouldOpen);
      });

      const answer = item.querySelector('[data-faq-answer]');
      answer?.addEventListener('transitionend', (event) => {
        if (event.propertyName === 'height' && item.classList.contains('is-open')) {
          answer.style.height = 'auto';
        }
      });
    });

    loadMoreButton?.addEventListener('click', () => {
      const hiddenItems = items.filter((item) => item.hidden);
      hiddenItems.slice(0, itemsPerLoad).forEach((item) => {
        item.hidden = false;
      });

      if (!items.some((item) => item.hidden)) {
        const loadMoreWrap = loadMoreButton.closest('.custom-faq-section__load-more-wrap');
        if (loadMoreWrap) loadMoreWrap.hidden = true;
      }
    });
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('[data-faq-section]')) initializeSection(scope);
    scope.querySelectorAll('[data-faq-section]').forEach(initializeSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
